import React, { ChangeEvent, useState } from 'react';
import axios from 'ps-components/lib/apiClient';
import { Button } from '../../../../../ps-aspect-design';
import Search from 'ps-components/Search/Search';
import { useToast } from 'ps-shared-ui/v4/Toast';
import { TOAST_ERROR_OPTIONS } from '../../../../../constants';
import { UserI } from '../types';
import UserTable from './UserTable/UserTable';
import UpdatePrimarySubsite from './UpdatePrimarySubsite/UpdatePrimarySubsite';
import './UserLookup.scss';

const UserLookup = () => {
  const [userSearch, setUserSearch] = useState('');
  const [user, setUser] = useState<UserI | null>(null);
  const toast = useToast();

  const handleChange = (searchValue: string) => {
    setUserSearch(searchValue);
    setUser(null);
  };

  const findUser = async () => {
    try {
      const response = await axios.apiGet(`/api/marketpay-internal/users/subsite?email=${userSearch}`);
      if (response.data?.success && response.data?.user) {
        setUser(response.data.user);
      } else {
        toast(response.data.message, TOAST_ERROR_OPTIONS);
      }
    } catch (error) {
      toast(error, TOAST_ERROR_OPTIONS);
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      findUser();
    }
  };

  return (
    <>
      <div className="user_search__container">
        <div className="user_searchbar__container">
          <Search
            className="user_searchbar"
            value={userSearch}
            onClick={() => handleChange('')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e.target.value)}
            placeholder="Find User by Username or Email"
            onKeyDown={handleKeyDown}
          />
        </div>
        <Button disabled={!userSearch.length} onClick={findUser}>
          Find
        </Button>
      </div>
      {user && <UserTable user={user} />}
      {user && <UpdatePrimarySubsite user={user} setUser={setUser} />}
    </>
  );
};

export default UserLookup;
